import { useCallback } from 'react'
import { useNavigate } from 'react-router-dom'
import { clearSessionStores, clearAllOfflineStores } from '../offline/clear-all'
import { stopOfflineDataSync } from '../offline/offline-data-sync'

/**
 * @param {Object} [options]
 * @param {boolean} [options.clearOfflineUsers=false] - Se true, cancella anche init snapshot e tutto offlineData (hard logout).
 */
const useLogout = ({ clearOfflineUsers = false } = {}) => {
  const navigate = useNavigate()

  return useCallback(async () => {
    stopOfflineDataSync()

    if (clearOfflineUsers) {
      await clearAllOfflineStores().catch(() => {})
    } else {
      await clearSessionStores().catch(() => {})
    }

    try {
      localStorage.removeItem('adams_user')
      localStorage.removeItem('token')
    } catch {
      /* ignore */
    }
    sessionStorage.clear()

    navigate('/', { replace: true })
  }, [navigate, clearOfflineUsers])
}

export default useLogout
